<div #viewportRoot class="virtual-list-viewport">
  <div class="virtual-list-viewport__spacer" [style.height.px]="topSpacerHeight"></div>

  <div
    *ngFor="let entry of visibleItems; trackBy: trackVisibleItem"
    #renderedItem
    class="virtual-list-viewport__item"
    [attr.data-virtual-key]="entry.key"
  >
    <ng-container
      *ngTemplateOutlet="resolvedTemplate; context: { $implicit: entry.item, item: entry.item, index: entry.index, key: entry.key }"
    ></ng-container>
  </div>

  <div class="virtual-list-viewport__spacer" [style.height.px]="bottomSpacerHeight"></div>
  <div #appendSentinel class="virtual-list-viewport__append-sentinel" aria-hidden="true"></div>
</div>
